<template>
	<div class="userinfo" v-loading="data_loading" ref="height_top" v-bind:style="{ height: tableHeight + 'px' }" style="overflow: auto;">
		<div style="">
			<el-row>
				<el-col :span="24">
					<el-row>
						<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="custom-col-24">
							<div class="addr_title">
								<el-input v-model="search.linkman" style="width: 200px" placeholder="请输入用户名" />
								<el-button-group class="button">
									<el-button style="color:#ff8a5c" @click='gethelpers'>查询</el-button>
									<el-button style="color:#ff8a5c" @click="add_data">新增</el-button>
								</el-button-group>
							</div>
						</el-col>
					</el-row>
					<el-row>
						<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="custom-col-24" v-for="item in data">
							<div class="addr_content">
								<el-row>
									<el-col :span="12">
										<div class="title">
											<span class="name" v-if="item.user_id==user_id">
												{{item.helper_name}}
											</span>
											<span class="name" v-else>
												{{item.user_name}}
											</span>
											<span>
												|
											</span>
											<!-- type  0是正在审核 1 是通过 2是拒绝 -->
											<span v-if="item.type==1" style="color:#29afa5">
												已通过
											</span>
											<span v-else-if="item.type==2" style="color:red">
												已拒绝
											</span>
											<span v-else style="color:#ff8a5c">
												正在申请中
											</span>
										</div>
									</el-col>
									<el-col :span="12">
										<div class="title_ma" style="text-align:right" v-if="item.user_id==user_id">
											<span>
												<el-button size="small" style="color:#ff8a5c" text >编辑</el-button>
											</span>
											<span>
												|
											</span>
											<span>
												<el-button size="small" style="color:red" text @click="del(item.id)">删除</el-button>
											</span>
										</div>
										<div class="title_ma" style="text-align:right" v-else-if="item.type===0">
											<span>
												<el-button size="small" style="color:#409EFF" text @click="audithelpers(item.id,1)">同意</el-button>
											</span>
											<span>
												|
											</span>
											<span>
												<el-button size="small" style="color:red" text @click="audithelpers(item.id,2)">拒绝</el-button>
											</span>
											<span>
												<el-button size="small" style="color:red" text @click="del(item.id)">删除</el-button>
											</span>
										</div>
										<div class="title_ma" style="text-align:right;height: 100%;padding-bottom: 0rem;" v-else>
											<span>
												<el-button size="small" style="color:red" text @click="del(item.id)">删除</el-button>
											</span>
										</div>
									</el-col>
								</el-row>
								<el-row style="color:#6a6867" class="content">
									<el-col :span="24" class="phone">
										<el-row>
											<el-col :xs="24" :sm="12" :md="6" :lg="2" :xl="2">
												<span class="" v-if="item.user_id==user_id">
													{{item.helper_name}}
												</span>
												<span class="" v-else>
													{{item.user_name}}
												</span>
											</el-col>
											<el-col :xs="24" :sm="12" :md="6" :lg="4" :xl="3">手机号：
												<span class="" v-if="item.user_id==user_id">
													{{item.mobile}}
												</span>
												<span class="" v-else>
													{{item.user_mobile}}
												</span>
											</el-col>
											<el-col :xs="24" :sm="12" :md="6" :lg="4" :xl="3">功能：</el-col>
										</el-row>
									</el-col>
								</el-row>
							</div>
							<!--  -->
						</el-col>
					</el-row>
				</el-col>
			</el-row>
		</div>
		<el-dialog title="帮手" v-model="addr_show" width="800px" :close-on-click-modal="false">
			<el-form :model="form" ref="formData" :rules="rules" label-width="auto">
				<el-row>
					<el-col :span="24">
						<!-- <el-col :span="24">
							<el-form-item label="收件人：" prop="linkman">
								<el-input v-model="form.linkman" />
							</el-form-item>
						</el-col> -->
						<el-col :span="24">
							<el-form-item label="手机号：" prop="mobile">
								<el-input v-model="form.mobile" />
							</el-form-item>
						</el-col>
						<!-- <el-col :span="24">
							<el-form-item label="电话：" prop="tel">
								<el-input v-model="form.tel" />
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item label="邮编：" prop="zip_code">
								<el-input v-model="form.zip_code" />
							</el-form-item>
						</el-col>
						<el-col :span="24" class="">
							<el-row>
								<el-col :xs="16" :sm="14" :md="14" :lg="14" :xl="10">
									<el-form-item label="所在地区：" prop="province_id">
										<el-select v-model="form.province_id" placeholder="请选择省份" @change="changeProvices">
											<el-option :label="item.name" v-for="(item,key) in provices" :value="item.id"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :xs="4" :sm="5" :md="5" :lg="5" :xl="7">
									<el-form-item label="" prop="city_id">
										<el-select v-model="form.city_id" placeholder="请输入城市" @change="changeCity">
											<el-option :label="item.name" v-for="(item,key) in city" :value="item.id"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :xs="4" :sm="5" :md="5" :lg="5" :xl="7">
									<el-form-item label="" prop="district_id">
										<el-select v-model="form.district_id" placeholder="请输入区" @change="changeDistrict">
											<el-option :label="item.name" v-for="(item,key) in district" :value="item.id"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
							</el-row>
						</el-col>
						<el-col :span="24">
							<el-form-item label="地址：" prop="address">
								<el-input v-model="form.address" placeholder="请输入收货地址">
									<template #prepend>{{form.province_city}}</template>
								</el-input>
							</el-form-item>
						</el-col> -->
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer" center="right">
				<el-button @click="addr_show = false">取 消</el-button>
				<el-button type="primary" @click="saveuser" :loading='loading'>确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
import { ElMessage, ElMessageBox } from 'element-plus'
export default {
	components: {},
	data() {

		return {
			search: {
				linkman: '',
			},
			data_loading: false,
			data: [{}],
			tableHeight: '',
			addr_show: false,
			form: {},
			rules: { //change


				mobile: [{
					required: true,
					message: '请填写手机号',
					trigger: 'blur'
				}],
			},
			district: [],
			provices: [],
			city: [],
			loading: false,
			user_id: '',

		}
	},
	props: [],

	updated() {

	},


	mounted() {

	},

	activated() {

	},
	created() {
		this.user_id = localStorage.getItem('user_id');
		this.gethelpers();
		this.tableHeight_fun();
	},
	watch: {

	},
	methods: {
		add_data() {
			this.form = {};
			this.addr_show = true;
		},
		audithelpers(id, type) {
			if (type == 1) {
				var msg = "确认同意成为此账号的帮手？"
			} else {
				var msg = "确认拒绝成为此账号的帮手？"
			}
			ElMessageBox.confirm(
					msg,
					'提示', {
						confirmButtonText: '确认',
						cancelButtonText: '取消',
						type: 'warning',
					}
				)
				.then(() => {
					this.audithelpers_ajax(id, type)
				})
				.catch(() => {

				})
		},
		async audithelpers_ajax(id, type) {
			await this.$axios.post('/api/yunsys.Website/audithelpers', { id, type }).then(async (res) => {
					var res = res.data;
					if (res.code !== 0) {
						return ElMessage({
							message: res.msg,
							type: 'error',
							grouping: true // 开启合并功能
						})
					}
					this.gethelpers();
					if (type==1) {
						ElMessageBox.confirm(
							'您已同意成为帮手，若需使用帮手功能，请重新登录！',
							'提示', {
								confirmButtonText: '确认',
								cancelButtonText: '取消',
								type: 'warning',
							}
						)
						.then(() => {
							localStorage.removeItem('token')
							localStorage.removeItem('user_id')
							localStorage.removeItem('username')
							localStorage.removeItem('mobile')
							this.$router.push('/login');
							return false
						})
						.catch(() => {

						})
					}else{
						return ElMessage({
							message: res.msg,
							type: 'success',
							grouping: true // 开启合并功能
						})
					}
					
					/**/

				})
				.catch(err => {
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})
		},
		del(id) {
			ElMessageBox.confirm(
					'确认删除此帮手，不可恢复！',
					'提示', {
						confirmButtonText: '确认',
						cancelButtonText: '取消',
						type: 'warning',
					}
				)
				.then(() => {
					this.del_ajax(id)
				})
				.catch(() => {

				})

		},
		async del_ajax(id) {
			await this.$axios.post('/api/yunsys.Website/delhelpers', { id }).then(async (res) => {
					var res = res.data;
					if (res.code !== 0) {
						return ElMessage({
							message: res.msg,
							type: 'error',
							grouping: true // 开启合并功能
						})
					}
					this.gethelpers();
					return ElMessage({
						message: res.msg,
						type: 'success',
						grouping: true // 开启合并功能
					})

				})
				.catch(err => {
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})
		},

		save(item) {
			this.form = JSON.parse(JSON.stringify(item))
			this.form.province_id = item.province_id ? item.province_id : '';
			this.form.city_id = item.city_id ? item.city_id : '';
			this.form.district_id = item.district_id ? item.district_id : '';
			this.getcitys();
			this.getdistrict();
			this.addr_show = true;
		},
		async gethelpers() {
			this.data_loading = true;
			await this.$axios.post('/api/yunsys.Website/gethelpers', this.search).then(async (res) => {
					var res = res.data;
					this.data_loading = false;
					if (res.code !== 0) {
						return ElMessage({
							message: res.msg,
							type: 'error',
							grouping: true // 开启合并功能
						})
					} else {
						this.data = res.data;
					}

				})
				.catch(err => {
					this.data_loading = false;
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})
		},
		async saveuser() {
			var obj = this;
			this.$refs.formData.validate(async v => {
				if (v) {
					this.loading = true
					await this.$axios.post('/api/yunsys.Website/savehelpers', this.form).then(async (res) => {
							var res = res.data;
							this.loading = false
							if (res.code !== 0) {
								return ElMessage({
									message: res.msg,
									type: 'error',
									grouping: true // 开启合并功能
								})
							}
							this.addr_show = false;
							this.gethelpers();
							return ElMessage({
								message: res.msg,
								type: 'success',
								grouping: true // 开启合并功能
							})

						})
						.catch(err => {
							this.loading = false
							return ElMessage({
								message: '系统错误',
								type: 'error',
								grouping: true // 开启合并功能

							})
						})
				} else {
					return ElMessage({
						message: '请填写必填项',
						type: 'error',
						grouping: true // 开启合并功能

					})
				}
			})

		},
		tableHeight_fun() {
			this.$nextTick(() => {
				this.tableHeight = window.innerHeight - this.$refs.height_top.getBoundingClientRect().top - 55
			})
		},
	}
}
</script>
<style lang="less" scoped>
:deep(.el-dialog__body) {
	text-align: right;
}
</style>